import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { ClienteTypeaheadSharedModule } from '../../pessoa/cliente/typeahead';
import { MotivoPerdaVendaSelectModule } from '../../motivo-perda-venda/select';
import { ClientePipeSharedModule } from '../../pessoa/cliente/pipes';

import { ClienteCarteiraCongelarModalComponent } from './modal';
import { ClienteCarteiraCongeladoPipelineCardInfoComponent } from './pipeline-card-info';

@NgModule({
    imports: [
        SharedModule,
        ClienteTypeaheadSharedModule,
        MotivoPerdaVendaSelectModule,
        ClientePipeSharedModule
    ],
    declarations: [
        ClienteCarteiraCongelarModalComponent,
        ClienteCarteiraCongeladoPipelineCardInfoComponent
    ],
    exports: [
        SharedModule,

        ClienteCarteiraCongelarModalComponent,
        ClienteCarteiraCongeladoPipelineCardInfoComponent
    ],
    providers: [ ]
})
export class ClienteCarteiraCongelarModule { }
